import React from "react";
import {
  Button,
  Col,
  OverlayTrigger,
  Row,
  Table,
  Checkbox,
  Tooltip,
} from "react-bootstrap";
import LoadingSpinner from "views/Components/loadingSpinner";

const ClaimReconciliationTable = ({
  loading,
  noRecordFound,
  data,
  handleDeleteOrder,
  selectedClaimId,
  setSelectedClaimId,
}) => {
  const Delete = <Tooltip id="Delete">Delete</Tooltip>;

  return (
    <Row>
      <Col xs={12} sm={12} md={12} lg={12} style={{ padding: "28px" }}>
        <Table responsive>
          <thead>
            <tr>
              <th>
                <th>
                  {data.some((claimRec) => claimRec.status !== "Completed") && (
                    <input
                      type="checkbox"
                      checked={
                        data.length > 0 &&
                        data
                          .filter((claimRec) => claimRec.status !== "Completed")
                          .every((claimRec) =>
                            selectedClaimId.includes(claimRec.id),
                          )
                      }
                      onChange={(e) => {
                        if (e.target.checked) {
                          const allIds = data
                            .filter(
                              (claimRec) => claimRec.status !== "Completed",
                            )
                            .map((claimRec) => claimRec.id);
                          setSelectedClaimId(allIds);
                        } else {
                          setSelectedClaimId([]);
                        }
                      }}
                    />
                  )}
                </th>
              </th>
              <th>Invoice Number</th>
              <th>company name</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Status</th>
              <th>pdf</th>
              <th>Transaction Banking Excel</th>
              <th>Total</th>
              <th>type</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="8">
                  <LoadingSpinner />
                </td>
              </tr>
            ) : noRecordFound ? (
              <tr>
                <td colSpan="8">
                  <center>No record found</center>
                </td>
              </tr>
            ) : (
              data.map((claimRec, index) => (
                <tr key={index}>
                  <td>
                    {claimRec.status !== "Completed" ? (
                      <input
                        type="checkbox"
                        value={claimRec.id}
                        checked={selectedClaimId.includes(claimRec.id)}
                        onChange={() =>
                          setSelectedClaimId((prev) =>
                            prev.includes(claimRec.id)
                              ? prev.filter((id) => id !== claimRec.id)
                              : [...prev, claimRec.id],
                          )
                        }
                      />
                    ) : null}
                  </td>
                  <td>
                    {claimRec.type === "utilization invoice"
                      ? `CLM ${claimRec.id + 1000}`
                      : `SUB ${claimRec.id + 100}`}
                  </td>

                  <td>
                    {claimRec.company_name && claimRec.company_name.company_name
                      ? claimRec.company_name.company_name
                      : ""}
                  </td>
                  <td>{claimRec.start_date || "—"}</td>
                  <td>{claimRec.end_date || "—"}</td>
                  {claimRec.status === "Generated" ? (
                    <td>
                      <Button
                        className="btn btn-fill fl_text_orange"
                        style={{
                          padding: "auto",
                          width: "auto",
                          textTransform: "capitalize",
                          cursor: "auto",
                          padding: "4px 14px",
                          fontSize: "12px",
                        }}
                      >
                        Generated
                        <div style={{ fontSize: "10px" }}>
                          {claimRec.updated_at}
                        </div>
                      </Button>
                    </td>
                  ) : claimRec.status === "Completed" ? (
                    <td>
                      <Button
                        className=" btn btn-fill fl_text_green"
                        style={{
                          padding: "auto",
                          width: "auto",
                          textTransform: "capitalize",
                          cursor: "auto",
                          padding: "4px 14px",
                          fontSize: "12px",
                        }}
                      >
                        Completed
                        <div style={{ fontSize: "10px" }}>
                          {claimRec.updated_at}
                        </div>
                      </Button>
                    </td>
                  ) : claimRec.status === "Payment Received" ? (
                    <td>
                      <Button
                        className="btn btn-fill fl_text_contains_mainly_blue"
                        style={{
                          padding: "10px",
                          width: "auto",
                          textTransform: "capitalize",
                          cursor: "auto",
                          padding: "4px 14px",
                          fontSize: "12px",
                        }}
                      >
                        Payment Received
                        <div style={{ fontSize: "10px" }}>
                          {claimRec.updated_at}
                        </div>
                      </Button>
                    </td>
                  ) : claimRec.status === "Payment Request Sent" ? (
                    <td>
                      <Button
                        className="btn btn-fill  fl_text_red"
                        style={{
                          padding: "auto",
                          width: "auto",
                          textTransform: "capitalize",
                          cursor: "auto",
                          padding: "4px 14px",
                          fontSize: "12px",
                        }}
                      >
                        Payment Request Sent
                        <div style={{ fontSize: "10px" }}>
                          {claimRec.updated_at}
                        </div>
                      </Button>
                    </td>
                  ) : (
                    <td> - </td>
                  )}

                  <td>
                    <a
                      href={claimRec.pdf_url}
                      target="_blank"
                      rel="opener northerner"
                    >
                      <i
                        className="fas fa-file-pdf"
                        style={{
                          cursor: "pointer",
                          fontSize: "20px",
                          color: "red",
                        }}
                      ></i>
                    </a>
                  </td>
                  <td>
                    {claimRec.transaction_banking_url ? (
                      <a
                        href={claimRec.transaction_banking_url}
                        target="_blank"
                        rel="opener northerner"
                      >
                        <i
                          className="fas fa-file-excel"
                          style={{
                            cursor: "pointer",
                            fontSize: "20px",
                            color: "green",
                          }}
                        ></i>
                      </a>
                    ) : null}
                  </td>
                  <td>{claimRec.total}</td>
                  <td style={{ textTransform: "capitalize" }}>
                    {claimRec.type}
                  </td>
                  <td>
                    {claimRec.status !== "Completed" &&
                    claimRec.status !== "Payment Received" ? (
                      <OverlayTrigger placement="top" overlay={Delete}>
                        <Button
                          className="btn-simple btn btn-xs btn-danger"
                          bsStyle="danger"
                          bsSize="xs"
                          style={{ border: "none" }}
                          onClick={() => handleDeleteOrder(claimRec.id)}
                        >
                          <i className="fa fa-times" />
                        </Button>
                      </OverlayTrigger>
                    ) : null}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </Col>
    </Row>
  );
};
export default ClaimReconciliationTable;
